"use client";

import React from "react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
interface SupportCtaCopy {
  eyebrow: string;
  heading: string;
  lead: string;
  secondaryLabel: string;
  note: string;
}
const copyData: Record<Lang, SupportCtaCopy> = {
  en: {
    eyebrow: "Standards & Specifications",
    heading: "Need Custom Mesh Specifications or Material Verification?",
    lead: "Our filtration specialists assist with mesh selection, alloy compatibility, custom aperture tolerances, and international standards compliance.",
    secondaryLabel: "Contact Our Team",
    note: "Manufacturing and aperture verification aligned with ASTM E2016 and ISO 9044"
  },
  zh: {
    eyebrow: "标准与规范支持",
    heading: "需要定制丝网技术规范或材质合规验证？",
    lead: "我们的技术专家协助完成丝网选型、合金耐腐蚀匹配、特殊孔径公差评定及国际标准符合性核验。",
    secondaryLabel: "联系我们",
    note: "制造公差与孔径验证严密遵循 ASTM E2016 与 ISO 9044 标准"
  },
  es: {
    eyebrow: "Normas y especificaciones",
    heading: "¿Necesita especificaciones personalizadas o verificación de material?",
    lead: "Nuestros especialistas en filtración le asisten en la selección de malla, compatibilidad de aleaciones y cumplimiento de normas internacionales.",
    secondaryLabel: "Contacte con nosotros",
    note: "Fabricación y verificación de aberturas conforme a ASTM E2016 e ISO 9044"
  },
  de: {
    eyebrow: "Normen & Spezifikationen",
    heading: "Benötigen Sie kundenspezifische Spezifikationen oder Werkstoffnachweise?",
    lead: "Unsere Filtrationsspezialisten unterstützen Sie bei der Gewebeauswahl, Legierungskompatibilität und Einhaltung internationaler Standards.",
    secondaryLabel: "Kontakt aufnehmen",
    note: "Fertigung und Öffnungsprüfung abgestimmt auf ASTM E2016 und ISO 9044"
  },
  fr: {
    eyebrow: "Normes et spécifications",
    heading: "Besoin de spécifications sur mesure ou de vérification de matière ?",
    lead: "Nos spécialistes en filtration vous accompagnent dans le choix de la toile, la compatibilité des alliages et le respect des normes internationales.",
    secondaryLabel: "Nous contacter",
    note: "Fabrication et vérification d'ouverture alignées sur ASTM E2016 et ISO 9044"
  },
  pt: {
    eyebrow: "Normas e especificações",
    heading: "Precisa de especificações personalizadas ou verificação de material?",
    lead: "Nossos especialistas auxiliam na seleção da malha, compatibilidade de ligas e conformidade com normas internacionais.",
    secondaryLabel: "Fale conosco",
    note: "Fabricação e verificação de abertura alinhadas aos padrões ASTM E2016 e ISO 9044"
  }
};
export default function SupportCta() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, copyData);
  return <CtaBand id="supportcta" eyebrow={content.eyebrow} heading={content.heading} lead={content.lead} primary={{
    label: pick(lang, COMMON.requestQuote),
    to: "/RequestAQuotePage"
  }} secondary={{
    label: content.secondaryLabel,
    to: "/ContactPage"
  }} note={content.note} />;
}